/**
 * Scoring utility for V2 AI-Visibility categories.
 * Maps category keys to display info, provides score color/label helpers.
 */
import { OptimizationTest } from '../types/api';

export type V2CategoryKey = 'entity' | 'content' | 'reputation' | 'usp' | 'local' | 'thirdparty' | 'technical';

export const CATEGORY_ORDER: V2CategoryKey[] = [
  'entity', 'content', 'reputation', 'usp', 'local', 'thirdparty', 'technical',
];

export const CATEGORY_CONFIG: Record<V2CategoryKey, { name: string; number: number }> = {
  entity:     { name: 'Entity-Klarheit & Konsistenz',       number: 1 },
  content:    { name: 'Zitierfähigkeit & Content-Qualität',  number: 2 },
  reputation: { name: 'Reputation & Bewertungsprofil',       number: 3 },
  usp:        { name: 'USP & Differenzierung',              number: 4 },
  local:      { name: 'Lokale & Regionale Relevanz',        number: 5 },
  thirdparty: { name: 'Drittquellen-Autorität',             number: 6 },
  technical:  { name: 'Technische Signale & Datenstruktur', number: 7 },
};

/**
 * Get the color for a score per bewertungskonzept.md
 */
export function getScoreColor(score: number): string {
  if (score >= 90) return '#1B7A3D'; // Dunkelgrün
  if (score >= 75) return '#4CAF50'; // Grün
  if (score >= 60) return '#F9A825'; // Gelb/Amber
  if (score >= 40) return '#FF8F00'; // Orange
  return '#D32F2F';                   // Rot
}

/**
 * Get the German label for a score
 */
export function getScoreLabel(score: number): string {
  if (score >= 90) return 'Exzellent';
  if (score >= 75) return 'Gut';
  if (score >= 60) return 'Ausbaufähig';
  if (score >= 40) return 'Schwach';
  return 'Kritisch';
}

/**
 * Check if a test uses the V2 scoring system
 */
export function isV2Test(test: OptimizationTest): boolean {
  return (test.scoring_version ?? 1) >= 2;
}
